module.exports = __webpack_public_path__ + "static/cortex-about-sean-min-76c7b0a1c3372454416d3adedff97ab1.png";